if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Gallery thumbnails

			if ( this.productSlider ) {

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top,
									behavior: 'smooth'
								});
								this.#thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.#thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					const activeGalleryItem = this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`);
					if ( activeGalleryItem && activeGalleryItem.dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', activeGalleryItem.dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}
				});

				// The slider rebuilds its slides from an HTML snapshot when it's torn
				// down (watchCSS, crossing the desktop breakpoint), which can predate
				// the last variant change - re-apply the variant filter to the new nodes.

				this.productSlider.addEventListener('destroy', ()=>{
					if ( this.productVariants ) {
						this.#filterGalleryByVariant(this.productVariants.currentVariant);
					}
				});

			}

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {

				this.productVariants.addEventListener('VARIANT_CHANGE', this.#onVariantChangeHandler.bind(this));
				this.#onVariantChangeHandler({target:this.productVariants});

				// refresh color
				this.querySelectorAll('.product-variant__item--radio input').forEach(input=>{
					input.addEventListener('click', () => {
						const inputParent = input.closest('.product-variant__item--radio');
						if ( inputParent.classList.contains('product-variant__item--color' ) ) {
							const label = inputParent.closest('.product-variant').querySelector('.product-variant__item-text-label');
							if ( label ) {
								label.textContent = input.value;
							}
						}
					})
				});

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
							if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				this._buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				this._buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

		}

		disconnectedCallback(){
			if ( this._buyObserver ) {
				this._buyObserver.disconnect();
			}
		}

		#thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach(elm=>{
				if ( elm.dataset.index == index ) {
					elm.classList.add('active');
					this.querySelector('.product-gallery__thumbnails-holder').scrollTo({
						left: elm.offsetLeft - 50,
						behavior: 'smooth'
					})
				} else {
					elm.classList.remove('active');
				}
			});
		}

		// Variant gallery filtering. Media tagged through its alt text
		// ("Name#OptionName_OptionValue", any number of tags, parsed in
		// sections/main-product.liquid into data-variant-media-tags) only shows
		// while every one of its tagged option values is selected; untagged media
		// always shows. Mirrors the Liquid that sets the initial `hidden` state,
		// including its two fallbacks: no variant selected yet, or nothing left
		// to show for this variant -> show everything.
		//
		// The AR slide opens on the first image still showing and stands in for
		// that image's own slide, which stays hidden (Liquid renders it hidden
		// rather than leaving it out, so it can come back here once a later
		// variant change moves the AR photo to a different image).

		#filterGalleryByVariant(variant){

			if ( ! this.productGallery ) {
				return;
			}

			const items = [...this.productGallery.querySelectorAll('.product-gallery-item')];
			if ( ! items.some(elm=>elm.hasAttribute('data-variant-media-tags')) ) {
				return;
			}

			// a child product's image Shopify pulled into a combined-listing parent
			// (see sections/main-product.liquid) - never shown
			const excluded = elm => elm.hasAttribute('data-variant-media-excluded');
			const normalize = value => typeof value == 'string' ? value.trim().toLowerCase() : null;
			const matches = elm => {
				if ( excluded(elm) ) {
					return false;
				}
				if ( ! variant || ! elm.hasAttribute('data-variant-media-tags') ) {
					return true;
				}
				return JSON.parse(elm.dataset.variantMediaTags).every(([position, value])=>{
					const selected = normalize(variant.options[position]);
					return selected !== null && selected == normalize(value);
				});
			};
			const showAll = ! items.some(elm=>elm.dataset.mediaId && matches(elm));
			const filtered = elm => excluded(elm) || ( ! showAll && ! matches(elm) );

			const arPhoto = this.productGallery.querySelector('.product-gallery-item--ar [data-ar-photo] img');
			const standIn = arPhoto ? items.find(elm=>elm.dataset.mediaId && elm.dataset.productMediaType == 'image' && ! filtered(elm)) : null;
			const sliderEnabled = this.productSlider && this.productSlider.sliderEnabled;

			let changed = false,
				index = 0;

			items.forEach(elm=>{
				const hide = filtered(elm) || elm === standIn;
				if ( elm.hidden != hide ) {
					changed = true;
				}
				elm.hidden = hide;
				elm.dataset.index = hide ? -1 : index++;
				// slides that were hidden when the slider initialised never got its class
				if ( sliderEnabled && ! hide ) {
					elm.classList.add('css-slide');
				}
				if ( elm.dataset.mediaId ) {
					const thumbnail = this.querySelector(`.product-gallery__thumbnails .thumbnail[data-media-id="${elm.dataset.mediaId}"]`);
					if ( thumbnail ) {
						// the stand-in's thumbnail opens the AR slide
						thumbnail.hidden = filtered(elm);
						thumbnail.dataset.index = elm === standIn ? 0 : elm.dataset.index;
					}
				}
			});

			// Checked on its own: moving the stand-in from one hidden image to
			// another (eg. one Performance Technology to the next) changes the AR
			// photo without changing which slides show.
			const standInImg = standIn ? standIn.querySelector('.lazy-image img') : null;
			if ( arPhoto && standInImg && arPhoto.getAttribute('src') !== standInImg.getAttribute('src') ) {
				['srcset', 'src', 'alt', 'width', 'height'].forEach(attr=>{
					const value = standInImg.getAttribute(attr);
					if ( value !== null ) {
						arPhoto.setAttribute(attr, value);
					}
				});
			}

			if ( ! changed ) {
				return;
			}

			this.firstProductGalleryIndex = null;

			if ( sliderEnabled ) {
				if ( this.productSlider.indexedItems.length > 0 ) {
					this.productSlider.afterAppend();
					this.productSlider.resetSlider();
				} else {
					// initialised with a single slide, so it never set up its
					// observer/navigation - rebuild it around the new set of slides
					this.productSlider.destroySlider();
					this.productSlider.initSlider();
				}
			}

			this.#thumbnailNavigationHelper(0);

		}

		#onVariantChangeHandler(e){

			// Confirmed live that scrolling away from the AR slide on a later
			// variant change (not just on page-load) was the actual bug reported —
			// the 3D scene already reflects every variant change live in place, so
			// the gallery should never navigate off it at all, on load or after.
			const hasArSlide = this.productGallery && this.productGallery.querySelector('.product-gallery-item--ar') != null;

			let variant = e.target.currentVariant;
			this.#filterGalleryByVariant(variant);
			if ( variant ) {

				// image handling

				if ( variant.featured_media != null && ! hasArSlide ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg && ! variantImg.hidden ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							variantImg.scrollIntoView({behavior: 'smooth', block: 'center'});
						}
					}
				}
				
				this.querySelectorAll('.product-variant__item--color [data-selected]').forEach(elm=>{
					// The PDP restyle's swatch rows don't all carry a `.product-variant__item-text-label`
					// element (see .pdp-option-row--variant in section-main-product-pdp.css) — guard
					// against that instead of throwing, which was aborting the rest of this handler on
					// every variant change.
					const label = elm.closest('.product-variant').querySelector('.product-variant__item-text-label');
					if ( label ) {
						label.textContent = elm.value;
					}
				});

			}

		}
		
	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}